import React from 'react';
import './SettingsPage.css';
import { FaSun, FaMoon, FaCircleHalfStroke } from 'react-icons/fa6';
import useAuth from '../hooks/useAuth';
import useTheme from '../hooks/useTheme';
import MfaEnroll from '../components/MfaEnroll';

const THEME_OPTIONS = [
  { id: 'light', label: 'Light', Icon: FaSun },
  { id: 'dark', label: 'Dark', Icon: FaMoon },
  { id: 'auto', label: 'Auto', Icon: FaCircleHalfStroke },
];

// Colour scheme picker. The preference lives in this browser (localStorage),
// not on the account, so it isn't part of the profile form below.
const AppearanceCard = () => {
  const { mode, theme, setMode } = useTheme();

  return (
    <section className="settings-card glass">
      <h2>Appearance</h2>
      <div className="theme-toggle" role="radiogroup" aria-label="Colour scheme">
        {THEME_OPTIONS.map(({ id, label, Icon }) => (
          <button
            key={id}
            type="button"
            role="radio"
            aria-label={label}
            aria-checked={mode === id}
            className={`theme-option ${mode === id ? 'active' : ''}`}
            onClick={() => setMode(id)}
          >
            <Icon aria-hidden="true" />
            <span>{label}</span>
          </button>
        ))}
      </div>
      <p className="settings-hint">
        {mode === 'auto'
          ? `Following your device setting — currently ${theme}.`
          : `Always ${mode}. Saved on this device.`}
      </p>
    </section>
  );
};

// Account settings for a signed-in user. Home of the two-step verification
// (MFA) setup. Access (auth required) is enforced by ProtectedRoute, so a user
// is guaranteed here.
export default function SettingsPage() {
  const user = useAuth();

  if (!user) {
    return (
      <div className="settings">
        <p className="settings-loading">Loading…</p>
      </div>
    );
  }

  return (
    <div className="settings">
      <h1 className="settings-title">Settings</h1>

      <section className="settings-card glass">
        <h2>Account</h2>
        <dl className="settings-meta">
          <dt>Name</dt>
          <dd>{user.displayName || '—'}</dd>
          <dt>Email</dt>
          <dd>{user.email || '—'}</dd>
        </dl>
      </section>

      <AppearanceCard />

      <section className="settings-card glass">
        <h2>Security</h2>
        <MfaEnroll user={user} />
      </section>
    </div>
  );
}
